import { snapshot } from 'valtio';
import { FilterElements } from '../../common/filters-utils/filters-utils';
import { SupplyChainItem } from '../../supply-chain/supplychain-types';
import ArtifactsStore from '../stores/artifacts-store';
import {
  ArtifactInfo,
  ArtifactTopFiilter,
  ArtifactTopFiltersTypes,
  FilterArtifactsType,
} from '../types/artifacts-type';

export const setArtifacts = (artifacts: ArtifactInfo[], update: boolean) => {
  if (update) {
    ArtifactsStore.artifacts = artifacts;
  } else {
    ArtifactsStore.artifacts?.push(...artifacts);
  }
};

export const setArtifactsTotalNumber = (totalArtifacts: number) => {
  ArtifactsStore.total = totalArtifacts;
};

export const setArtifactModal = (artifactModal: boolean) => {
  ArtifactsStore.artifactModal = artifactModal;
};

export const setArtifactsOffset = (offset: number) => {
  ArtifactsStore.offset = offset;
};

export const setSelectedArtifact = (artifact: ArtifactInfo | null) => {
  ArtifactsStore.selectedArtifact = artifact;
};

export const setSelectedArtifactId = (artifactId: string) => {
  ArtifactsStore.selectedArtifactId = artifactId;
};

export const setLoadingSingleartifact = (loading: boolean) => {
  ArtifactsStore.loadingArtifact = loading;
};

export const setTotalFilterdArtifacts = (totalFiltered: number) => {
  ArtifactsStore.totalFiltered = totalFiltered;
};

export const toggleFiltersPanel = () => {
  ArtifactsStore.filtersOpen = !ArtifactsStore.filtersOpen;
};

export const setArtifactsFiltersList = (
  artifactsFiltresList: FilterArtifactsType,
) => {
  ArtifactsStore.artifactsFiltersList = artifactsFiltresList;
};

export const setArtifactsTopFiltersList = (
  artifactsTopFiltersList: ArtifactTopFiilter[],
) => {
  ArtifactsStore.artifactsTopFiltersList = artifactsTopFiltersList;
};

export const clearStore = () => {
  ArtifactsStore.filterArtifactsBy = {};
  // ArtifactsStore.artifacts = [];
  ArtifactsStore.selectedArtifact = null;
  ArtifactsStore.selectedArtifactId = '';
  ArtifactsStore.total = 0;
  ArtifactsStore.topFiltersArtifactsBy = [];
};

export const filtersExists = (filter: ArtifactTopFiltersTypes) => {
  return ArtifactsStore.topFiltersArtifactsBy.includes(filter);
};

export const addFilter = (filter: ArtifactTopFiltersTypes) => {
  ArtifactsStore.topFiltersArtifactsBy.push(filter);
};

export const removeFilter = (filter: ArtifactTopFiltersTypes) => {
  ArtifactsStore.topFiltersArtifactsBy =
    ArtifactsStore.topFiltersArtifactsBy.filter(f => f !== filter);
};

export const updateFilters = (filter: ArtifactTopFiltersTypes) => {
  filtersExists(filter) ? removeFilter(filter) : addFilter(filter);
  return ArtifactsStore.topFiltersArtifactsBy;
};

export const setSupplyChainItems = (supplyChainItems: SupplyChainItem[]) => {
  if (ArtifactsStore.selectedArtifact) {
    ArtifactsStore.selectedArtifact.supplyChainItems = supplyChainItems;
  }
};

export const setSearchValues = (type: string, searchValue: string) => {
  ArtifactsStore.searchValues[type] = searchValue;
};

export const setStoreArtifactsFiltersTypeSearch = (
  artifactsFilters: FilterArtifactsType,
): void => {
  const { searchValues } = snapshot(ArtifactsStore);
  ArtifactsStore.artifactsFiltersTypeSearch = Object.keys(
    artifactsFilters,
  ).reduce((acc, key) => {
    acc[key] = searchValues[key]
      ? artifactsFilters[key].filter((f: FilterElements) =>
          f.label.toLocaleLowerCase().includes(searchValues[key].toLowerCase()),
        )
      : artifactsFilters[key];
    return acc;
  }, {} as FilterArtifactsType);
};
